var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3812 13.236C11.9339 13.0521 13.4594 12.6857 14.9262 12.1443C13.684 10.7683 12.9977 8.97972 13.0004 7.12598V6.54264V6.50098C13.0004 5.17489 12.4736 3.90312 11.5359 2.96544C10.5982 2.02776 9.32648 1.50098 8.0004 1.50098C6.67431 1.50098 5.40255 2.02776 4.46486 2.96544C3.52718 3.90312 3.0004 5.17489 3.0004 6.50098V7.12598C3.00291 8.97983 2.31622 10.7684 1.07373 12.1443C2.5179 12.6776 4.0404 13.0485 5.61956 13.236M10.3812 13.236C8.79955 13.4236 7.20124 13.4236 5.61956 13.236M10.3812 13.236C10.5013 13.6109 10.5312 14.0088 10.4684 14.3974C10.4056 14.786 10.2519 15.1543 10.0199 15.4723C9.78784 15.7903 9.48399 16.049 9.13306 16.2273C8.78213 16.4057 8.39404 16.4986 8.0004 16.4986C7.60675 16.4986 7.21867 16.4057 6.86774 16.2273C6.51681 16.049 6.21296 15.7903 5.98091 15.4723C5.74887 15.1543 5.5952 14.786 5.53241 14.3974C5.46962 14.0088 5.49948 13.6109 5.61956 13.236",
    stroke: "#575E76",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.7a768dfb5aa42e45267f6838990eb6b8.svg";
export { ForwardRef as ReactComponent };